export default __webpack_public_path__ + "static/media/Scania_13_NOV.8e2d21a4.pdf";